import type { CampaignBanner } from '@gyym/sdk'
import { Image, Link } from '@gyym/ui'
import React from 'react'

import { useAuthUser } from '@/modules/Auth'
import { BannerViewType } from '@/modules/Top'
import { getImageUrl } from '@/utils/getImageUrl'

export interface CampaignBannerSwiperProps {
  campaignBanners: CampaignBanner[]
}

export const CampaignBannerSwiper = ({
  campaignBanners,
}: CampaignBannerSwiperProps) => {
  const { isLoggedIn } = useAuthUser()

  const banners = React.useMemo(() => {
    return campaignBanners.filter(
      ({ viewType }) =>
        viewType === BannerViewType.ALWAYS ||
        (isLoggedIn
          ? viewType === BannerViewType.ONLY_LOGIN
          : viewType === BannerViewType.ONLY_LOGOUT),
    )
  }, [campaignBanners, isLoggedIn])

  return (
    <div className="mx-auto w-full px-3 pc:max-w-[960px] pc:px-0">
      <div className="grid grid-cols-1 gap-2 tablet:grid-cols-2 tablet:gap-4">
        {banners.map((banner, i) => (
          <Link
            href={banner.destUrl}
            key={banner.id}
            external
            className="relative block"
          >
            <div className="relative w-full [&_img]:h-auto [&_img]:w-full [&_img]:object-cover">
              <Image
                src={getImageUrl(banner.imagePath)}
                alt={`Campaign Banner ${i + 1}`}
                width={408}
                height={143}
                loading={i < 2 ? undefined : 'lazy'}
                preload={i < 2}
              />
            </div>
          </Link>
        ))}
      </div>
    </div>
  )
}
